/**
 * Coordonnées & informations stables du site.
 * Source unique de vérité — modifier ici se propage partout.
 */
export const SITE = {
  name: "K&C Services",
  url: "https://ketc-services.com",
  city: "Yaoundé, Cameroun",
  email: "contact@ketc-services.com",
  phoneDisplay: "+237 693 892 851",
  phoneE164: "+237693892851",
  whatsappNumber: "237693892851",
  whatsappDefaultMessage: "Bonjour K&C Services, je souhaite échanger sur un projet.",
  hours: {
    week: "Lundi — Vendredi · 8h30 — 18h00",
    saturday: "Samedi · 9h00 — 13h00",
  },
  legal: {
    company: "K&C Services SARL",
    rcs: "RC/YAO/2023/A/2644",
    niu: "P039818383815S",
    capital: "1 000 000 FCFA",
    address: "Yaoundé, Cameroun",
    director: "Direction Générale — K&C Services",
    host: {
      name: "OVH SAS",
      address: "2 rue Kellermann, 59100 Roubaix, France",
      site: "https://www.ovh.com",
    },
  },
} as const;

export const whatsappLink = (message = SITE.whatsappDefaultMessage) =>
  `https://wa.me/${SITE.whatsappNumber}?text=${encodeURIComponent(message)}`;
